<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<lms-message-tab *ngIf="selectedTab && selectedTab.subTypeDetail?.data?.message" [message]="selectedTab.subTypeDetail?.data?.message" (clearMessage)="clearErrorMessage($event)"></lms-message-tab>

<lms-loco-status-header [tab]="selectedTab" [tabs]="filteredTabs" [locoStatusArr]='locoStatusArr' [lastRefreshTime]='selectedTab?.lastRefreshTime' (refreshBtnEvent)="refreshbtnEvent($event)"></lms-loco-status-header>

<lms-loco-status-sub-header (allocateDellocateEvent)='allocateDellocateEvent($event)' [locoStatusArr]='locoStatusArr' (cancelLocomotivePlan)='openCancelLocomotivePlanPopup();' (planOrCurrentAssignment)="openPlanOrCurrentAssignmentPopup($event)" [isSelectedLocos]='isSelectedLocos' [isShowCancelLocoPlan]='isShowCancelLocoPlan'></lms-loco-status-sub-header>

<lms-loco-status-container (updateDataStoreEventEmit)='updateDataStore();' (searchClickEventEmit)='searchClickEventEmit($event)' (removeLocoEmit)="removeLocoEmit($event)" (onLocoSelect)='showLocomotiveContextMenu($event);' [locoStatusArr]='locoStatusArr'
    (doubleEnterEvent)='doubleEnterEvent($event);' (locoSelecttionEVent)='locoSelecttionEVent();'></lms-loco-status-container>

<lms-loco-context-menu [windowCode]="'LWLS'" [isLocoStatusScreen]='true' [loco]='selectedLoco' *ngIf="selectedLoco" [locoId]='selectedLocoId'></lms-loco-context-menu>

<!-- START PLAN LOCOMOTIVE OR SET CURRENT ASSIGNMENT POPUP -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id='locoStatusPlanLocoId' (onHide)="resetPageMode()" (onShow)='setPageModeData("planSubmitPopup"); setFocusToGivenElement("locoStatusPlanTrainInput");' [(visible)]="planOrSetCurrentAssignment" [resizable]="false" [draggable]="false" [closable]="true"
    class="{{errorDialog?'terminal-ui-popups error-dialog':'terminal-ui-popups'}} {{setCurrentAssignment?'current-assignment-dialog':''}}" header="{{popUpErrorMessage}}" modal="true" closeOnEscape="true">
    <div *ngIf="planOrSetCurrentAssignment">
        <div class="plan-to">
            <div class="plan-to-dropdown {{setCurrentAssignment?'set-current-assign':'plan'}}">
                <label *ngIf="!setCurrentAssignment">{{configData && configData.locoStatusLabel.planTo}}</label>
                <label *ngIf="setCurrentAssignment">Set current assignment to</label>
                <p-dropdown [panelStyleClass]="'dialog-dropdown'" class="pull-left" (keydown)="setTabIndex($event)" tabindex="{{tabLevel+1}}"  [options]="planOption" inputId="currentAsignDropDown" (onChange)='changePlanOptions()' [(ngModel)]='selectedPlan'></p-dropdown>
            </div>

            <div class="plan-to-input {{setCurrentAssignment?'train':'plan'}}" *ngIf="selectedPlan === 'Train'">
                <label>{{configData && configData.locoStatusLabel.train}}</label>
                <span class="select-train-terminal">
				<input id="locoStatusPlanTrainInput" type="text" placeholder="Train ID" tabindex="{{tabLevel+1}}" spellcheck="false"  class="{{isAddTrainError ? 'p-inputfield train-placeholder p-inputfield-error' : 'p-inputfield train-placeholder'}}"  name="planTrainId" [(ngModel)]="planTrainId" required minlength="6" maxlength="6">
				<div class="color-red" *ngIf='isAddTrainError'>{{configData && configData.messages.planInvalidTrainId}}</div>
				</span>
            </div>

            <div class="plan-to-input {{setCurrentAssignment?'terminal':'plan'}}" *ngIf="selectedPlan !== 'Train'">
                <label>{{configData && configData.locoStatusLabel.terminal}}</label>
                <span class="select-train-terminal">
					<lms-autocomplete [tabindex]='tabLevel+2' styleclass="p-autocomplete" spellcheck="false" [inputId]='"locoStatusPlanTerminalSearchBox"' [(ngModel)]="searchPlanTextTerminal" [ngClass]="'terminal-autocomplete'"
						placeholder="Mnemonic" [suggestions]="filteredResults" (completeMethod)="autoCompleteForTerminal($event)" [minLength]="2" (onSelect)="selectValueFromAutoComplete(searchPlanTextTerminal,'terminalPlanSuggestSearch')"
                        [maxlength]="6" (keydown.space)='$event.stopPropagation();' (keydown.spacebar)='$event.stopPropagation();' (keyup.space)='$event.stopPropagation();' (keyup.spacebar)='$event.stopPropagation();' 
                        inputStyleClass="{{searchPlanTextTerminalError ? 'p-inputfield-error' : ''}}" >
                    </lms-autocomplete>	
                    <font class="update-terminal-text" *ngIf="!setCurrentAssignment && selectedPlan ==='Terminal'"> Enter terminal.  Press TAB to evaluate servicing capability.</font>
          <div class="color-red" *ngIf='searchPlanTextTerminalError'> {{configData && configData.messages.planInvalidTerminal}} </div>		
			  </span>
            </div>

            <div class="plan-to-input frr-road {{setCurrentAssignment?'road':'plan'}}"
                [hidden]="selectedPlan !=='Foreign Railroad'"
            >
                <label>{{configData && configData.locoStatusLabel.road}}</label>
                <span class="select-train-terminal">
                    <p-autoComplete
                        #autoComplete
                        [(ngModel)]="selectedTerminalRoad"
                        styleClass="{{selectedTerminalRoadError ? 'p-inputfield-error pull-left p-dropdown' : 'pull-left p-dropdown'}}"
                        ngModel
                        name='roadValue' 
                        [tabindex]='tabLevel+3'
                        (onFocus)="onFocusTerminalRoad($event, autoComplete)"
                        (onSelect)="onSelectTerminalRoad(value)"
                        (input)="terminalRoadModelValueChange($event)"
                        [suggestions]="filteredRoadValuesObj"
                        field="label"
                        [disabled]="!checkIfTerminalValid()"
                        (completeMethod)="filterSelectedTerminalRoad($event)"
                        [size]="30"
                        [autoHighlight]="true"
                        placeholder="Road"
                    >
                        <ng-template let-roadValue pTemplate="roadValue">
                            <div class="p-helper-clearfix">
                                <div>{{roadValue.label}}</div>
                            </div>
                        </ng-template>
                    </p-autoComplete>
                    <div class="color-red" *ngIf='selectedTerminalRoadError'> {{configData && configData.messages.planInvalidRoad}} </div>
                </span>
            </div>
            <!-- <div class="plan-to-input frr-road {{setCurrentAssignment?'road':'plan'}}" [hidden]="selectedPlan !=='Foreign Railroad'">
                <label>{{configData && configData.locoStatusLabel.road}}</label>
                <span class="select-train-terminal">
          <p-dropdown [tabindex]='tabLevel+3' [filter]="true" [options]="selectedRoadValues" disabled="{{!selectedTerminalRoad}}" styleClass="{{selectedTerminalRoadError ? 'p-inputfield-error pull-left p-dropdown' : 'pull-left p-dropdown'}}" ngModel autoWidth="true" name='roadValue' [(ngModel)]='selectedTerminalRoad' (onFocus)="onFocusTerminalRoad($event)" (input)="terminalRoadModelValueChange($event)" >
            <ng-template let-roadValue pTemplate="roadValue">
              <div class="p-helper-clearfix"><div> {{roadValue.label}} </div></div>
            </ng-template>
          </p-dropdown>
				  <div class="color-red" *ngIf='selectedTerminalRoadError'> {{configData && configData.messages.planInvalidRoad}} </div>
				</span>
            </div> -->

            <div class="terminal-handling-plan" [hidden]="selectedPlan === 'Foreign Railroad' || (setCurrentAssignment)">
                <h2>{{configData && configData.locoStatusLabel.terminalHandlingPlan}}</h2>
                <ul>
                    <li *ngIf="!isValidThpSelection">
                        <p-radioButton [tabindex]='tabLevel+4' name="radioButtonPlanLoco" value="S" label="{{configData && configData.locoStatusLabel.serviceCtrShop}}" [(ngModel)]="thpPlanLoco"></p-radioButton>
                    </li>
                    <li>
                        <p-radioButton [tabindex]='tabLevel+5' name="radioButtonPlanLoco" value="T" label="{{configData && configData.locoStatusLabel.truckFueling}}" [(ngModel)]="thpPlanLoco"></p-radioButton>
                    </li>
                    <li>
                        <p-radioButton [tabindex]='tabLevel+6' name="radioButtonPlanLoco" value="M" label="{{configData && configData.locoStatusLabel.mainTrack}}" [(ngModel)]="thpPlanLoco"></p-radioButton>
                    </li>
                    <li *ngIf="user && user.isUserManagerOrDirector">
                        <p-radioButton [tabindex]='tabLevel+7' name="radioButtonPlanLoco" value="X" label="{{configData && configData.locoStatusLabel.toStorage}}" [(ngModel)]="thpPlanLoco"></p-radioButton>
                    </li>
                </ul>
            </div>
            <div class="clear"></div>
        </div>

        <div class="items-to-plan" *ngIf="setCurrentAssignment || (!setCurrentAssignment && (selectedPlan !=='Train'))">
            <h2>{{configData && configData.locoStatusLabel.locomotives}} ({{selectedLocoStatusArr.length }})</h2>
            <ul>
                <li *ngFor="let locoStatus of selectedLocoStatusArr">
                    {{ locoStatus.searcheLocomotiveIdentifier }}
                </li>
            </ul>
        </div>
        <div class="items-to-plan" *ngIf="!setCurrentAssignment && (selectedPlan ==='Train')">
            <div class="plan-loco-table">
                <div class="table">
                    <div class="table-header">
                        <div class="columns-loco">{{configData && configData.locoStatusLabel.locomotive}} ({{selectedLocoStatusArr.length }})</div>
                        <div class="columns-iu" *ngIf="!setCurrentAssignment">{{configData && configData.locoStatusLabel.intendedUsage}}</div>
                        <div class="columns-reason" *ngIf="!setCurrentAssignment">{{configData && configData.locoStatusLabel.reason}}</div>
                        <div class="columns-notes" *ngIf="!setCurrentAssignment"> </div>
                    </div>
                    <div class="table-body">
                        <div class="table-row" *ngFor="let loco of selectedLocoStatusArr; let i = index">
                            <lms-intended-usage [tabLevel]='tabLevel + 10 + (i*5)' [locoData]='loco' [indexPosition]='i'></lms-intended-usage>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div class="dialog-buttons">
            <span class="pull-left">
				<button class="p-button-secondary" id="planCancelPopup" tabindex="{{tabLevel+101}}" (click)="hidePlanOrSetCurrentAssignmentPopup()">{{configData && configData.locoStatusLabel.cancel}}</button>
			</span>
            <span class="pull-right">
			<button class="p-button-primary" id="planSubmitPopup" tabindex="{{tabLevel+102}}" (keydown.tab)="tabOnSubmit($event)" (click)="submitPlanOrCurrentAssignment()">{{configData && configData.locoStatusLabel.submit}}</button>
			</span>
        </div>
    </div>
</p-dialog>
<!-- END PLAN LOCOMOTIVE POPUP -->

<!-- Start Rule Exception Popup -->
<p-dialog transitionOptions="0ms" [baseZIndex]="1000" id='locoStatusRuleExceptionId' [resizable]="false" [draggable]="false" (onShow)='setPageModeData("ruleExceptionLocoData","locoStatusRuleExceptionId");' (onHide)="resetRuleException();" class="terminal-ui-popups rule-exceptions" header="Rules Warning"
    [(visible)]="ruleException" modal="true" closeOnEscape="true">
    <div class="bre-dialog-header">
        <div class="plan-to-dropdown">
            <label class="pull-left block-32">{{configData && configData.locoStatusLabel.planToTrain}}</label>
            <span class="loco-tag">{{planTrainId ? planTrainId.toUpperCase() : '-'}}</span>
        </div>

    </div>
    <div class="exception-reason">
        <span class="exception-icon"></span>
        <div class="exception-details">
            <span class="color-red">Exception with {{(lmsExceptionList && lmsExceptionList.length > 1) ? lmsExceptionList.length : '' }} Planned {{(lmsExceptionList
			&& lmsExceptionList.length > 1) ? 'Locomotives' : 'Locomotive' }}</span>
            <p class="info-text">To <span>Override Rule</span>,{{(lmsExceptionList && lmsExceptionList.length > 1) ? ' Select Loco and hit submit. Unselected Loco will be auto cancelled.': ' add Reason and hit submit.' }}</p>
        </div>

    </div>
    <div class="exceptions-tbl-head">

        <span class="locomotive-head">{{configData && configData.locoStatusLabel.locomotive}}</span>
        <span class="exception-intended-usage-head">INTENDED USAGE INFO</span>
        <span class="exception-info-head">WARNING</span>

    </div>

    <div class="exception-dialog">

        <div class="exception-list">
            <div class="exception-rows" *ngFor='let lException of lmsExceptionList; let i = index'>
                <lms-bre-exception [lmsException]='lException' (checkCheckedLoco)="checkCheckedLoco($event)"></lms-bre-exception>
            </div>
        </div>
    </div>
    <div class="dialog-buttons">
        <span class="pull-right">
								<button type="button" tabindex="{{tabLevel}}" class="p-button-secondary" (click)="cancelRuleException()">{{configData && configData.locoStatusLabel.cancel}}</button>
								<button type="button" tabindex="{{tabLevel+1}}" id='ruleExceptionLocoData' [ngClass]="isRuleExceptionSubmitEnabled? 'p-button-primary' : 'p-button-secondary p-button-disabled'" disabled="{{isRuleExceptionSubmitEnabled? '' : 'disabled'}}" (click)="ruleExceptionSubmit()">{{configData && configData.locoStatusLabel.submit}}</button>
							</span>
    </div>
</p-dialog>
<!-- END Rule Exception Popup -->